// @generated — do not edit manually
// Regenerate with: poetry run python -m sourcepilot.schema.codegen.cli_unified scaffold --app sourcepilot

import type { QueryName } from '@sourcepilot/generated/query-names';

// Compile-time guard: every `query:` below must be a registered
// canonical wire name — a renamed/removed backend query fails tsc.
const _checkQueryNames = <T extends Record<string, { query?: QueryName } & Record<string, unknown>>>(m: T): T => m;

export const routeMap = _checkQueryNames({
  "rflp-action-by-id": {
    path: "/rflpactions/[id]",
    linkPath: "/projects/[projectId]/action/[actionId]",
    model: "Action",
    type: "detail",
    query: "rflp-action-by-id",
    publicRoute: false,
  },
  "rflp-action-input-parameter-by-id": {
    path: "/rflpactioninputparameters/[id]",
    model: "ActionInputParameter",
    type: "detail",
    query: "rflp-action-input-parameter-by-id",
    publicRoute: false,
  },
  "rflp-action-output-parameter-by-id": {
    path: "/rflpactionoutputparameters/[id]",
    model: "ActionOutputParameter",
    type: "detail",
    query: "rflp-action-output-parameter-by-id",
    publicRoute: false,
  },
  "rflp-analysis-record-by-id": {
    path: "/rflpanalysisrecords/[id]",
    model: "AnalysisRecord",
    type: "detail",
    query: "rflp-analysis-record-by-id",
    publicRoute: false,
  },
  "rflp-attribute-value-by-id": {
    path: "/rflpattributevalues/[id]",
    model: "AttributeValue",
    type: "detail",
    query: "rflp-attribute-value-by-id",
    publicRoute: false,
  },
  "rflp-change-impact-by-id": {
    path: "/rflpchangeimpacts/[id]",
    model: "ChangeImpact",
    type: "detail",
    query: "rflp-change-impact-by-id",
    publicRoute: false,
  },
  "rflp-change-proposal-by-id": {
    path: "/rflpchangeproposals/[id]",
    model: "ChangeProposal",
    type: "detail",
    query: "rflp-change-proposal-by-id",
    publicRoute: false,
  },
  "rflp-connection-by-id": {
    path: "/rflpconnections/[id]",
    model: "Connection",
    type: "detail",
    query: "rflp-connection-by-id",
    publicRoute: false,
  },
  "rflp-constraint-by-id": {
    path: "/rflpconstraints/[id]",
    model: "Constraint",
    type: "detail",
    query: "rflp-constraint-by-id",
    publicRoute: false,
  },
  "rflp-control-port-by-id": {
    path: "/rflpcontrolports/[id]",
    model: "ControlPort",
    type: "detail",
    query: "rflp-control-port-by-id",
    publicRoute: false,
  },
  "rflp-derived-expression-by-id": {
    path: "/rflpderivedexpressions/[id]",
    model: "DerivedExpression",
    type: "detail",
    query: "rflp-derived-expression-by-id",
    publicRoute: false,
  },
  "rflp-derived-value-by-id": {
    path: "/rflpderivedvalues/[id]",
    model: "DerivedValue",
    type: "detail",
    query: "rflp-derived-value-by-id",
    publicRoute: false,
  },
  "rflp-discrete-attribute-by-id": {
    path: "/rflpdiscreteattributes/[id]",
    model: "DiscreteAttribute",
    type: "detail",
    query: "rflp-discrete-attribute-by-id",
    publicRoute: false,
  },
  "rflp-github-repo-by-id": {
    path: "/rflpgithubrepos/[id]",
    model: "GitHubRepo",
    type: "detail",
    query: "rflp-github-repo-by-id",
    publicRoute: false,
  },
  "rflp-organisation-github-repos": {
    path: "/rflpgithubrepos",
    model: "GitHubRepo",
    type: "list",
    query: "rflp-organisation-github-repos",
    publicRoute: false,
  },
  "rflp-interface-port-by-id": {
    path: "/rflpinterfaceports/[id]",
    model: "InterfacePort",
    type: "detail",
    query: "rflp-interface-port-by-id",
    publicRoute: false,
  },
  "base-all-invites": {
    path: "/invites",
    model: "Invite",
    type: "list",
    query: "base-all-invites",
    publicRoute: false,
  },
  "rflp-item-by-id": {
    path: "/rflpitems/[id]",
    model: "Item",
    type: "detail",
    query: "rflp-item-by-id",
    publicRoute: false,
  },
  "rflp-item-flow-by-id": {
    path: "/rflpitemflows/[id]",
    model: "ItemFlow",
    type: "detail",
    query: "rflp-item-flow-by-id",
    publicRoute: false,
  },
  "rflp-logical-part-by-id": {
    path: "/rflplogicalparts/[id]",
    linkPath: "/projects/[projectId]/logical-part/[logicalPartId]",
    model: "LogicalPart",
    type: "detail",
    query: "rflp-logical-part-by-id",
    publicRoute: false,
  },
  "chat-model-request-by-id": {
    path: "/model-requests/[id]",
    model: "ModelRequest",
    type: "detail",
    query: "chat-model-request-by-id",
    publicRoute: false,
  },
  "chat-model-request-with-response": {
    path: "/model-requests/[id]/model-response/parts",
    model: "ResponsePart",
    type: "sub",
    query: "chat-model-request-with-response",
    sourceModel: "ModelRequest",
    publicRoute: false,
    relationship: "parts",
  },
  "chat-model-response-by-id": {
    path: "/model-responses/[id]",
    model: "ModelResponse",
    type: "detail",
    query: "chat-model-response-by-id",
    publicRoute: false,
  },
  "chat-model-response-with-parts": {
    path: "/model-responses/[id]/parts",
    model: "ResponsePart",
    type: "sub",
    query: "chat-model-response-with-parts",
    sourceModel: "ModelResponse",
    publicRoute: false,
    relationship: "parts",
  },
  "rflp-numeric-attribute-by-id": {
    path: "/rflpnumericattributes/[id]",
    model: "NumericAttribute",
    type: "detail",
    query: "rflp-numeric-attribute-by-id",
    publicRoute: false,
  },
  "base-all-organisations": {
    path: "/organisations",
    model: "Organisation",
    type: "list",
    query: "base-all-organisations",
    publicRoute: false,
  },
  "base-organisation-by-id": {
    path: "/organisations/[id]",
    model: "Organisation",
    type: "detail",
    query: "base-organisation-by-id",
    publicRoute: false,
  },
  "pdmproduct-full_requirements": {
    path: "/products/[id]/requirements",
    model: "PDMRequirement",
    type: "dag-sub",
    query: "pdm-product-with-requirements",
    sourceModel: "PDMProduct",
    publicRoute: false,
    parentDag: "pdmproduct-full",
    relationship: "requirements",
  },
  "pdmproduct-full_requirements_id": {
    path: "/products/[id]/requirements/[requirementsId]",
    model: "PDMRequirement",
    type: "dag-sub-detail",
    sourceModel: "PDMProduct",
    publicRoute: false,
    parentDag: "pdmproduct-full",
    relationship: "requirements",
  },
  "pdmproduct-full_actions": {
    path: "/products/[id]/actions",
    model: "PDMAction",
    type: "dag-sub",
    query: "pdm-product-with-actions",
    sourceModel: "PDMProduct",
    publicRoute: false,
    parentDag: "pdmproduct-full",
    relationship: "actions",
  },
  "pdmproduct-full_actions_id": {
    path: "/products/[id]/actions/[actionsId]",
    model: "PDMAction",
    type: "dag-sub-detail",
    sourceModel: "PDMProduct",
    publicRoute: false,
    parentDag: "pdmproduct-full",
    relationship: "actions",
  },
  "pdmproduct-full_root_part": {
    path: "/products/[id]/parts",
    model: "PDMPart",
    type: "dag-sub",
    sourceModel: "PDMProduct",
    publicRoute: false,
    parentDag: "pdmproduct-full",
    relationship: "root_part",
  },
  "pdmproduct-full_root_part_id": {
    path: "/products/[id]/parts/[root_partId]",
    model: "PDMPart",
    type: "dag-sub-detail",
    sourceModel: "PDMProduct",
    publicRoute: false,
    parentDag: "pdmproduct-full",
    relationship: "root_part",
  },
  "pdmproduct-full_supply_chain": {
    path: "/products/[id]/supply-chain-criteria",
    model: "PDMSupplyChainCriteria",
    type: "dag-sub",
    query: "pdm-product-with-supply-chain",
    sourceModel: "PDMProduct",
    publicRoute: false,
    parentDag: "pdmproduct-full",
    relationship: "supply_chain",
  },
  "pdmproduct-full_supply_chain_id": {
    path: "/products/[id]/supply-chain-criteria/[supply_chainId]",
    model: "PDMSupplyChainCriteria",
    type: "dag-sub-detail",
    sourceModel: "PDMProduct",
    publicRoute: false,
    parentDag: "pdmproduct-full",
    relationship: "supply_chain",
  },
  "pdm-product-by-id": {
    path: "/products/[id]",
    linkPath: "/product/[productId]",
    model: "PDMProduct",
    type: "detail",
    query: "pdm-product-by-id",
    publicRoute: false,
    dagRoot: true,
  },
  "pdm-products-list": {
    path: "/products",
    model: "PDMProduct",
    type: "list",
    query: "pdm-products-list",
    publicRoute: false,
  },
  "rflp-physical-part-by-id": {
    path: "/rflpphysicalparts/[id]",
    linkPath: "/projects/[projectId]/physical-part/[physicalPartId]",
    model: "PhysicalPart",
    type: "detail",
    query: "rflp-physical-part-by-id",
    publicRoute: false,
  },
  "rflp-physics-port-by-id": {
    path: "/rflpphysicsports/[id]",
    model: "PhysicsPort",
    type: "detail",
    query: "rflp-physics-port-by-id",
    publicRoute: false,
  },
  "project-full_attribute_values": {
    path: "/rflpprojects/[id]/rflpattributevalues",
    model: "AttributeValue",
    type: "dag-sub",
    sourceModel: "Project",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "attribute_values",
  },
  "project-full_attribute_values_id": {
    path: "/rflpprojects/[id]/rflpattributevalues/[attribute_valuesId]",
    model: "AttributeValue",
    type: "dag-sub-detail",
    sourceModel: "Project",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "attribute_values",
  },
  "project-full_derived_values": {
    path: "/rflpprojects/[id]/rflpderivedvalues",
    model: "DerivedValue",
    type: "dag-sub",
    sourceModel: "Project",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "derived_values",
  },
  "project-full_derived_values_id": {
    path: "/rflpprojects/[id]/rflpderivedvalues/[derived_valuesId]",
    model: "DerivedValue",
    type: "dag-sub-detail",
    sourceModel: "Project",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "derived_values",
  },
  "project-full_proposal_batches": {
    path: "/rflpprojects/[id]/rflpproposalbatchs",
    model: "ProposalBatch",
    type: "dag-sub",
    sourceModel: "Project",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "proposal_batches",
  },
  "project-full_proposal_batches_id": {
    path: "/rflpprojects/[id]/rflpproposalbatchs/[proposal_batchesId]",
    model: "ProposalBatch",
    type: "dag-sub-detail",
    sourceModel: "Project",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "proposal_batches",
  },
  "project-full_root_part": {
    path: "/rflpprojects/[id]/rflplogicalparts",
    model: "LogicalPart",
    type: "dag-sub",
    sourceModel: "Project",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "root_part",
  },
  "project-full_root_part_id": {
    path: "/rflpprojects/[id]/rflplogicalparts/[root_partId]",
    model: "LogicalPart",
    type: "dag-sub-detail",
    sourceModel: "Project",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "root_part",
  },
  "project-full_physical_parts": {
    path: "/rflpprojects/[id]/rflpphysicalparts",
    model: "PhysicalPart",
    type: "dag-sub",
    sourceModel: "Project",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "physical_parts",
  },
  "project-full_physical_parts_id": {
    path: "/rflpprojects/[id]/rflpphysicalparts/[physical_partsId]",
    model: "PhysicalPart",
    type: "dag-sub-detail",
    sourceModel: "Project",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "physical_parts",
  },
  "project-full_software_parts": {
    path: "/rflpprojects/[id]/rflpsoftwareparts",
    model: "SoftwarePart",
    type: "dag-sub",
    sourceModel: "Project",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "software_parts",
  },
  "project-full_software_parts_id": {
    path: "/rflpprojects/[id]/rflpsoftwareparts/[software_partsId]",
    model: "SoftwarePart",
    type: "dag-sub-detail",
    sourceModel: "Project",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "software_parts",
  },
  "project-full_reachable_action_id": {
    path: "/rflpprojects/[id]/rflpactions/[rflpactionsId]",
    model: "Action",
    type: "dag-sub-detail",
    sourceModel: "Project",
    publicRoute: false,
    parentDag: "project-full",
  },
  "project-full_reachable_action_id_attribute_values": {
    path: "/rflpprojects/[id]/rflpactions/[rflpactionsId]/attribute-values",
    model: "AttributeValue",
    type: "dag-sub",
    sourceModel: "Action",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "attribute_values",
  },
  "project-full_reachable_action_id_derived_values": {
    path: "/rflpprojects/[id]/rflpactions/[rflpactionsId]/derived-values",
    model: "DerivedValue",
    type: "dag-sub",
    sourceModel: "Action",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "derived_values",
  },
  "project-full_reachable_action_id_mentioned_in_expressions": {
    path: "/rflpprojects/[id]/rflpactions/[rflpactionsId]/mentioned-in-expressions",
    model: "Expression",
    type: "dag-sub",
    sourceModel: "Action",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "mentioned_in_expressions",
  },
  "project-full_reachable_action_id_parent": {
    path: "/rflpprojects/[id]/rflpactions/[rflpactionsId]/parent",
    model: "LogicalPart",
    type: "dag-sub",
    sourceModel: "Action",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "parent",
  },
  "project-full_reachable_action_id_sub_actions": {
    path: "/rflpprojects/[id]/rflpactions/[rflpactionsId]/sub-actions",
    model: "Action",
    type: "dag-sub",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "sub_actions",
  },
  "project-full_reachable_action_id_satisfies": {
    path: "/rflpprojects/[id]/rflpactions/[rflpactionsId]/satisfies",
    model: "Requirement",
    type: "dag-sub",
    sourceModel: "Action",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "satisfies",
  },
  "project-full_reachable_action_id_verifies": {
    path: "/rflpprojects/[id]/rflpactions/[rflpactionsId]/verifies",
    model: "Requirement",
    type: "dag-sub",
    sourceModel: "Action",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "verifies",
  },
  "project-full_reachable_action_id_performed_by": {
    path: "/rflpprojects/[id]/rflpactions/[rflpactionsId]/performed-by",
    model: "LogicalPart",
    type: "dag-sub",
    sourceModel: "Action",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "performed_by",
  },
  "project-full_reachable_action_id_input_parameters": {
    path: "/rflpprojects/[id]/rflpactions/[rflpactionsId]/input-parameters",
    model: "ActionInputParameter",
    type: "dag-sub",
    sourceModel: "Action",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "input_parameters",
  },
  "project-full_reachable_action_id_output_parameters": {
    path: "/rflpprojects/[id]/rflpactions/[rflpactionsId]/output-parameters",
    model: "ActionOutputParameter",
    type: "dag-sub",
    sourceModel: "Action",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "output_parameters",
  },
  "project-full_reachable_action_id_bound_parameters": {
    path: "/rflpprojects/[id]/rflpactions/[rflpactionsId]/bound-parameters",
    model: "ActionParameter",
    type: "dag-sub",
    sourceModel: "Action",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "bound_parameters",
  },
  "project-full_reachable_action_id_outgoing_successions": {
    path: "/rflpprojects/[id]/rflpactions/[rflpactionsId]/outgoing-successions",
    model: "Succession",
    type: "dag-sub",
    sourceModel: "Action",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "outgoing_successions",
  },
  "project-full_reachable_action_id_incoming_successions": {
    path: "/rflpprojects/[id]/rflpactions/[rflpactionsId]/incoming-successions",
    model: "Succession",
    type: "dag-sub",
    sourceModel: "Action",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "incoming_successions",
  },
  "project-full_reachable_actioninputparameter_id": {
    path: "/rflpprojects/[id]/rflpactioninputparameters/[rflpactioninputparametersId]",
    model: "ActionInputParameter",
    type: "dag-sub-detail",
    sourceModel: "Project",
    publicRoute: false,
    parentDag: "project-full",
  },
  "project-full_reachable_actioninputparameter_id_attribute_values": {
    path: "/rflpprojects/[id]/rflpactioninputparameters/[rflpactioninputparametersId]/attribute-values",
    model: "AttributeValue",
    type: "dag-sub",
    sourceModel: "ActionInputParameter",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "attribute_values",
  },
  "project-full_reachable_actioninputparameter_id_derived_values": {
    path: "/rflpprojects/[id]/rflpactioninputparameters/[rflpactioninputparametersId]/derived-values",
    model: "DerivedValue",
    type: "dag-sub",
    sourceModel: "ActionInputParameter",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "derived_values",
  },
  "project-full_reachable_actioninputparameter_id_mentioned_in_expressions": {
    path: "/rflpprojects/[id]/rflpactioninputparameters/[rflpactioninputparametersId]/mentioned-in-expressions",
    model: "Expression",
    type: "dag-sub",
    sourceModel: "ActionInputParameter",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "mentioned_in_expressions",
  },
  "project-full_reachable_actioninputparameter_id_item": {
    path: "/rflpprojects/[id]/rflpactioninputparameters/[rflpactioninputparametersId]/item",
    model: "Item",
    type: "dag-sub",
    sourceModel: "ActionInputParameter",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "item",
  },
  "project-full_reachable_actioninputparameter_id_bound_to": {
    path: "/rflpprojects/[id]/rflpactioninputparameters/[rflpactioninputparametersId]/bound-to",
    model: "Action",
    type: "dag-sub",
    sourceModel: "ActionInputParameter",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "bound_to",
  },
  "project-full_reachable_actioninputparameter_id_owner_action": {
    path: "/rflpprojects/[id]/rflpactioninputparameters/[rflpactioninputparametersId]/owner-action",
    model: "Action",
    type: "dag-sub",
    sourceModel: "ActionInputParameter",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "owner_action",
  },
  "project-full_reachable_actioninputparameter_id_incoming_flows": {
    path: "/rflpprojects/[id]/rflpactioninputparameters/[rflpactioninputparametersId]/incoming-flows",
    model: "ItemFlow",
    type: "dag-sub",
    sourceModel: "ActionInputParameter",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "incoming_flows",
  },
  "project-full_reachable_actionoutputparameter_id": {
    path: "/rflpprojects/[id]/rflpactionoutputparameters/[rflpactionoutputparametersId]",
    model: "ActionOutputParameter",
    type: "dag-sub-detail",
    sourceModel: "Project",
    publicRoute: false,
    parentDag: "project-full",
  },
  "project-full_reachable_actionoutputparameter_id_attribute_values": {
    path: "/rflpprojects/[id]/rflpactionoutputparameters/[rflpactionoutputparametersId]/attribute-values",
    model: "AttributeValue",
    type: "dag-sub",
    sourceModel: "ActionOutputParameter",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "attribute_values",
  },
  "project-full_reachable_actionoutputparameter_id_derived_values": {
    path: "/rflpprojects/[id]/rflpactionoutputparameters/[rflpactionoutputparametersId]/derived-values",
    model: "DerivedValue",
    type: "dag-sub",
    sourceModel: "ActionOutputParameter",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "derived_values",
  },
  "project-full_reachable_actionoutputparameter_id_mentioned_in_expressions": {
    path: "/rflpprojects/[id]/rflpactionoutputparameters/[rflpactionoutputparametersId]/mentioned-in-expressions",
    model: "Expression",
    type: "dag-sub",
    sourceModel: "ActionOutputParameter",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "mentioned_in_expressions",
  },
  "project-full_reachable_actionoutputparameter_id_item": {
    path: "/rflpprojects/[id]/rflpactionoutputparameters/[rflpactionoutputparametersId]/item",
    model: "Item",
    type: "dag-sub",
    sourceModel: "ActionOutputParameter",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "item",
  },
  "project-full_reachable_actionoutputparameter_id_bound_to": {
    path: "/rflpprojects/[id]/rflpactionoutputparameters/[rflpactionoutputparametersId]/bound-to",
    model: "Action",
    type: "dag-sub",
    sourceModel: "ActionOutputParameter",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "bound_to",
  },
  "project-full_reachable_actionoutputparameter_id_owner_action": {
    path: "/rflpprojects/[id]/rflpactionoutputparameters/[rflpactionoutputparametersId]/owner-action",
    model: "Action",
    type: "dag-sub",
    sourceModel: "ActionOutputParameter",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "owner_action",
  },
  "project-full_reachable_actionoutputparameter_id_outgoing_flows": {
    path: "/rflpprojects/[id]/rflpactionoutputparameters/[rflpactionoutputparametersId]/outgoing-flows",
    model: "ItemFlow",
    type: "dag-sub",
    sourceModel: "ActionOutputParameter",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "outgoing_flows",
  },
  "project-full_reachable_changeproposal_id": {
    path: "/rflpprojects/[id]/rflpchangeproposals/[rflpchangeproposalsId]",
    model: "ChangeProposal",
    type: "dag-sub-detail",
    sourceModel: "Project",
    publicRoute: false,
    parentDag: "project-full",
  },
  "project-full_reachable_changeproposal_id_attribute_values": {
    path: "/rflpprojects/[id]/rflpchangeproposals/[rflpchangeproposalsId]/attribute-values",
    model: "AttributeValue",
    type: "dag-sub",
    sourceModel: "ChangeProposal",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "attribute_values",
  },
  "project-full_reachable_changeproposal_id_derived_values": {
    path: "/rflpprojects/[id]/rflpchangeproposals/[rflpchangeproposalsId]/derived-values",
    model: "DerivedValue",
    type: "dag-sub",
    sourceModel: "ChangeProposal",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "derived_values",
  },
  "project-full_reachable_changeproposal_id_mentioned_in_expressions": {
    path: "/rflpprojects/[id]/rflpchangeproposals/[rflpchangeproposalsId]/mentioned-in-expressions",
    model: "Expression",
    type: "dag-sub",
    sourceModel: "ChangeProposal",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "mentioned_in_expressions",
  },
  "project-full_reachable_changeproposal_id_batch": {
    path: "/rflpprojects/[id]/rflpchangeproposals/[rflpchangeproposalsId]/batch",
    model: "ProposalBatch",
    type: "dag-sub",
    sourceModel: "ChangeProposal",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "batch",
  },
  "project-full_reachable_connection_id": {
    path: "/rflpprojects/[id]/rflpconnections/[rflpconnectionsId]",
    model: "Connection",
    type: "dag-sub-detail",
    sourceModel: "Project",
    publicRoute: false,
    parentDag: "project-full",
  },
  "project-full_reachable_connection_id_attribute_values": {
    path: "/rflpprojects/[id]/rflpconnections/[rflpconnectionsId]/attribute-values",
    model: "AttributeValue",
    type: "dag-sub",
    sourceModel: "Connection",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "attribute_values",
  },
  "project-full_reachable_connection_id_derived_values": {
    path: "/rflpprojects/[id]/rflpconnections/[rflpconnectionsId]/derived-values",
    model: "DerivedValue",
    type: "dag-sub",
    sourceModel: "Connection",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "derived_values",
  },
  "project-full_reachable_connection_id_mentioned_in_expressions": {
    path: "/rflpprojects/[id]/rflpconnections/[rflpconnectionsId]/mentioned-in-expressions",
    model: "Expression",
    type: "dag-sub",
    sourceModel: "Connection",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "mentioned_in_expressions",
  },
  "project-full_reachable_connection_id_realized_by": {
    path: "/rflpprojects/[id]/rflpconnections/[rflpconnectionsId]/realized-by",
    model: "PhysicalPart",
    type: "dag-sub",
    sourceModel: "Connection",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "realized_by",
  },
  "project-full_reachable_connection_id_satisfies": {
    path: "/rflpprojects/[id]/rflpconnections/[rflpconnectionsId]/satisfies",
    model: "Requirement",
    type: "dag-sub",
    sourceModel: "Connection",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "satisfies",
  },
  "project-full_reachable_connection_id_realizes_item_flows": {
    path: "/rflpprojects/[id]/rflpconnections/[rflpconnectionsId]/realizes-item-flows",
    model: "ItemFlow",
    type: "dag-sub",
    sourceModel: "Connection",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "realizes_item_flows",
  },
  "project-full_reachable_connection_id_port_a": {
    path: "/rflpprojects/[id]/rflpconnections/[rflpconnectionsId]/port-a",
    model: "Port",
    type: "dag-sub",
    sourceModel: "Connection",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "port_a",
  },
  "project-full_reachable_connection_id_port_b": {
    path: "/rflpprojects/[id]/rflpconnections/[rflpconnectionsId]/port-b",
    model: "Port",
    type: "dag-sub",
    sourceModel: "Connection",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "port_b",
  },
  "project-full_reachable_constraint_id": {
    path: "/rflpprojects/[id]/rflpconstraints/[rflpconstraintsId]",
    model: "Constraint",
    type: "dag-sub-detail",
    sourceModel: "Project",
    publicRoute: false,
    parentDag: "project-full",
  },
  "project-full_reachable_constraint_id_attribute_values": {
    path: "/rflpprojects/[id]/rflpconstraints/[rflpconstraintsId]/attribute-values",
    model: "AttributeValue",
    type: "dag-sub",
    sourceModel: "Constraint",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "attribute_values",
  },
  "project-full_reachable_constraint_id_derived_values": {
    path: "/rflpprojects/[id]/rflpconstraints/[rflpconstraintsId]/derived-values",
    model: "DerivedValue",
    type: "dag-sub",
    sourceModel: "Constraint",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "derived_values",
  },
  "project-full_reachable_constraint_id_mentioned_in_expressions": {
    path: "/rflpprojects/[id]/rflpconstraints/[rflpconstraintsId]/mentioned-in-expressions",
    model: "Expression",
    type: "dag-sub",
    sourceModel: "Constraint",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "mentioned_in_expressions",
  },
  "project-full_reachable_constraint_id_mentions": {
    path: "/rflpprojects/[id]/rflpconstraints/[rflpconstraintsId]/mentions",
    model: "RFLPElement",
    type: "dag-sub",
    sourceModel: "Constraint",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "mentions",
  },
  "project-full_reachable_constraint_id_formalises": {
    path: "/rflpprojects/[id]/rflpconstraints/[rflpconstraintsId]/formalises",
    model: "Requirement",
    type: "dag-sub",
    sourceModel: "Constraint",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "formalises",
  },
  "project-full_reachable_constraint_id_parent_constraint": {
    path: "/rflpprojects/[id]/rflpconstraints/[rflpconstraintsId]/parent-constraint",
    model: "Constraint",
    type: "dag-sub",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "parent_constraint",
  },
  "project-full_reachable_constraint_id_child_constraints": {
    path: "/rflpprojects/[id]/rflpconstraints/[rflpconstraintsId]/child-constraints",
    model: "Constraint",
    type: "dag-sub",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "child_constraints",
  },
  "project-full_reachable_controlport_id": {
    path: "/rflpprojects/[id]/rflpcontrolports/[rflpcontrolportsId]",
    model: "ControlPort",
    type: "dag-sub-detail",
    sourceModel: "Project",
    publicRoute: false,
    parentDag: "project-full",
  },
  "project-full_reachable_controlport_id_attribute_values": {
    path: "/rflpprojects/[id]/rflpcontrolports/[rflpcontrolportsId]/attribute-values",
    model: "AttributeValue",
    type: "dag-sub",
    sourceModel: "ControlPort",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "attribute_values",
  },
  "project-full_reachable_controlport_id_derived_values": {
    path: "/rflpprojects/[id]/rflpcontrolports/[rflpcontrolportsId]/derived-values",
    model: "DerivedValue",
    type: "dag-sub",
    sourceModel: "ControlPort",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "derived_values",
  },
  "project-full_reachable_controlport_id_mentioned_in_expressions": {
    path: "/rflpprojects/[id]/rflpcontrolports/[rflpcontrolportsId]/mentioned-in-expressions",
    model: "Expression",
    type: "dag-sub",
    sourceModel: "ControlPort",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "mentioned_in_expressions",
  },
  "project-full_reachable_controlport_id_connections_as_a": {
    path: "/rflpprojects/[id]/rflpcontrolports/[rflpcontrolportsId]/connections-as-a",
    model: "Connection",
    type: "dag-sub",
    sourceModel: "ControlPort",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "connections_as_a",
  },
  "project-full_reachable_controlport_id_connections_as_b": {
    path: "/rflpprojects/[id]/rflpcontrolports/[rflpcontrolportsId]/connections-as-b",
    model: "Connection",
    type: "dag-sub",
    sourceModel: "ControlPort",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "connections_as_b",
  },
  "project-full_reachable_controlport_id_satisfies": {
    path: "/rflpprojects/[id]/rflpcontrolports/[rflpcontrolportsId]/satisfies",
    model: "Requirement",
    type: "dag-sub",
    sourceModel: "ControlPort",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "satisfies",
  },
  "project-full_reachable_controlport_id_owner": {
    path: "/rflpprojects/[id]/rflpcontrolports/[rflpcontrolportsId]/owner",
    model: "LogicalPart",
    type: "dag-sub",
    sourceModel: "ControlPort",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "owner",
  },
  "project-full_reachable_controlport_id_bound_to": {
    path: "/rflpprojects/[id]/rflpcontrolports/[rflpcontrolportsId]/bound-to",
    model: "LogicalPart",
    type: "dag-sub",
    sourceModel: "ControlPort",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "bound_to",
  },
  "project-full_reachable_derivedexpression_id": {
    path: "/rflpprojects/[id]/rflpderivedexpressions/[rflpderivedexpressionsId]",
    model: "DerivedExpression",
    type: "dag-sub-detail",
    sourceModel: "Project",
    publicRoute: false,
    parentDag: "project-full",
  },
  "project-full_reachable_derivedexpression_id_attribute_values": {
    path: "/rflpprojects/[id]/rflpderivedexpressions/[rflpderivedexpressionsId]/attribute-values",
    model: "AttributeValue",
    type: "dag-sub",
    sourceModel: "DerivedExpression",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "attribute_values",
  },
  "project-full_reachable_derivedexpression_id_derived_values": {
    path: "/rflpprojects/[id]/rflpderivedexpressions/[rflpderivedexpressionsId]/derived-values",
    model: "DerivedValue",
    type: "dag-sub",
    sourceModel: "DerivedExpression",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "derived_values",
  },
  "project-full_reachable_derivedexpression_id_mentioned_in_expressions": {
    path: "/rflpprojects/[id]/rflpderivedexpressions/[rflpderivedexpressionsId]/mentioned-in-expressions",
    model: "Expression",
    type: "dag-sub",
    sourceModel: "DerivedExpression",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "mentioned_in_expressions",
  },
  "project-full_reachable_derivedexpression_id_mentions": {
    path: "/rflpprojects/[id]/rflpderivedexpressions/[rflpderivedexpressionsId]/mentions",
    model: "RFLPElement",
    type: "dag-sub",
    sourceModel: "DerivedExpression",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "mentions",
  },
  "project-full_reachable_derivedexpression_id_result": {
    path: "/rflpprojects/[id]/rflpderivedexpressions/[rflpderivedexpressionsId]/result",
    model: "DerivedValue",
    type: "dag-sub",
    sourceModel: "DerivedExpression",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "result",
  },
  "project-full_reachable_interfaceport_id": {
    path: "/rflpprojects/[id]/rflpinterfaceports/[rflpinterfaceportsId]",
    model: "InterfacePort",
    type: "dag-sub-detail",
    sourceModel: "Project",
    publicRoute: false,
    parentDag: "project-full",
  },
  "project-full_reachable_interfaceport_id_attribute_values": {
    path: "/rflpprojects/[id]/rflpinterfaceports/[rflpinterfaceportsId]/attribute-values",
    model: "AttributeValue",
    type: "dag-sub",
    sourceModel: "InterfacePort",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "attribute_values",
  },
  "project-full_reachable_interfaceport_id_derived_values": {
    path: "/rflpprojects/[id]/rflpinterfaceports/[rflpinterfaceportsId]/derived-values",
    model: "DerivedValue",
    type: "dag-sub",
    sourceModel: "InterfacePort",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "derived_values",
  },
  "project-full_reachable_interfaceport_id_mentioned_in_expressions": {
    path: "/rflpprojects/[id]/rflpinterfaceports/[rflpinterfaceportsId]/mentioned-in-expressions",
    model: "Expression",
    type: "dag-sub",
    sourceModel: "InterfacePort",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "mentioned_in_expressions",
  },
  "project-full_reachable_interfaceport_id_connections_as_a": {
    path: "/rflpprojects/[id]/rflpinterfaceports/[rflpinterfaceportsId]/connections-as-a",
    model: "Connection",
    type: "dag-sub",
    sourceModel: "InterfacePort",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "connections_as_a",
  },
  "project-full_reachable_interfaceport_id_connections_as_b": {
    path: "/rflpprojects/[id]/rflpinterfaceports/[rflpinterfaceportsId]/connections-as-b",
    model: "Connection",
    type: "dag-sub",
    sourceModel: "InterfacePort",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "connections_as_b",
  },
  "project-full_reachable_interfaceport_id_standard": {
    path: "/rflpprojects/[id]/rflpinterfaceports/[rflpinterfaceportsId]/standard",
    model: "Standard",
    type: "dag-sub",
    sourceModel: "InterfacePort",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "standard",
  },
  "project-full_reachable_interfaceport_id_satisfies": {
    path: "/rflpprojects/[id]/rflpinterfaceports/[rflpinterfaceportsId]/satisfies",
    model: "Requirement",
    type: "dag-sub",
    sourceModel: "InterfacePort",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "satisfies",
  },
  "project-full_reachable_interfaceport_id_owner": {
    path: "/rflpprojects/[id]/rflpinterfaceports/[rflpinterfaceportsId]/owner",
    model: "LogicalPart",
    type: "dag-sub",
    sourceModel: "InterfacePort",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "owner",
  },
  "project-full_reachable_interfaceport_id_bound_to": {
    path: "/rflpprojects/[id]/rflpinterfaceports/[rflpinterfaceportsId]/bound-to",
    model: "LogicalPart",
    type: "dag-sub",
    sourceModel: "InterfacePort",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "bound_to",
  },
  "project-full_reachable_itemflow_id": {
    path: "/rflpprojects/[id]/rflpitemflows/[rflpitemflowsId]",
    model: "ItemFlow",
    type: "dag-sub-detail",
    sourceModel: "Project",
    publicRoute: false,
    parentDag: "project-full",
  },
  "project-full_reachable_itemflow_id_attribute_values": {
    path: "/rflpprojects/[id]/rflpitemflows/[rflpitemflowsId]/attribute-values",
    model: "AttributeValue",
    type: "dag-sub",
    sourceModel: "ItemFlow",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "attribute_values",
  },
  "project-full_reachable_itemflow_id_derived_values": {
    path: "/rflpprojects/[id]/rflpitemflows/[rflpitemflowsId]/derived-values",
    model: "DerivedValue",
    type: "dag-sub",
    sourceModel: "ItemFlow",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "derived_values",
  },
  "project-full_reachable_itemflow_id_mentioned_in_expressions": {
    path: "/rflpprojects/[id]/rflpitemflows/[rflpitemflowsId]/mentioned-in-expressions",
    model: "Expression",
    type: "dag-sub",
    sourceModel: "ItemFlow",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "mentioned_in_expressions",
  },
  "project-full_reachable_itemflow_id_item": {
    path: "/rflpprojects/[id]/rflpitemflows/[rflpitemflowsId]/item",
    model: "Item",
    type: "dag-sub",
    sourceModel: "ItemFlow",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "item",
  },
  "project-full_reachable_itemflow_id_unit": {
    path: "/rflpprojects/[id]/rflpitemflows/[rflpitemflowsId]/unit",
    model: "Unit",
    type: "dag-sub",
    sourceModel: "ItemFlow",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "unit",
  },
  "project-full_reachable_itemflow_id_realized_by": {
    path: "/rflpprojects/[id]/rflpitemflows/[rflpitemflowsId]/realized-by",
    model: "Connection",
    type: "dag-sub",
    sourceModel: "ItemFlow",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "realized_by",
  },
  "project-full_reachable_itemflow_id_source_parameter": {
    path: "/rflpprojects/[id]/rflpitemflows/[rflpitemflowsId]/source-parameter",
    model: "ActionOutputParameter",
    type: "dag-sub",
    sourceModel: "ItemFlow",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "source_parameter",
  },
  "project-full_reachable_itemflow_id_target_parameter": {
    path: "/rflpprojects/[id]/rflpitemflows/[rflpitemflowsId]/target-parameter",
    model: "ActionInputParameter",
    type: "dag-sub",
    sourceModel: "ItemFlow",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "target_parameter",
  },
  "project-full_reachable_physicsport_id": {
    path: "/rflpprojects/[id]/rflpphysicsports/[rflpphysicsportsId]",
    model: "PhysicsPort",
    type: "dag-sub-detail",
    sourceModel: "Project",
    publicRoute: false,
    parentDag: "project-full",
  },
  "project-full_reachable_physicsport_id_attribute_values": {
    path: "/rflpprojects/[id]/rflpphysicsports/[rflpphysicsportsId]/attribute-values",
    model: "AttributeValue",
    type: "dag-sub",
    sourceModel: "PhysicsPort",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "attribute_values",
  },
  "project-full_reachable_physicsport_id_derived_values": {
    path: "/rflpprojects/[id]/rflpphysicsports/[rflpphysicsportsId]/derived-values",
    model: "DerivedValue",
    type: "dag-sub",
    sourceModel: "PhysicsPort",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "derived_values",
  },
  "project-full_reachable_physicsport_id_mentioned_in_expressions": {
    path: "/rflpprojects/[id]/rflpphysicsports/[rflpphysicsportsId]/mentioned-in-expressions",
    model: "Expression",
    type: "dag-sub",
    sourceModel: "PhysicsPort",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "mentioned_in_expressions",
  },
  "project-full_reachable_physicsport_id_connections_as_a": {
    path: "/rflpprojects/[id]/rflpphysicsports/[rflpphysicsportsId]/connections-as-a",
    model: "Connection",
    type: "dag-sub",
    sourceModel: "PhysicsPort",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "connections_as_a",
  },
  "project-full_reachable_physicsport_id_connections_as_b": {
    path: "/rflpprojects/[id]/rflpphysicsports/[rflpphysicsportsId]/connections-as-b",
    model: "Connection",
    type: "dag-sub",
    sourceModel: "PhysicsPort",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "connections_as_b",
  },
  "project-full_reachable_physicsport_id_satisfies": {
    path: "/rflpprojects/[id]/rflpphysicsports/[rflpphysicsportsId]/satisfies",
    model: "Requirement",
    type: "dag-sub",
    sourceModel: "PhysicsPort",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "satisfies",
  },
  "project-full_reachable_physicsport_id_owner": {
    path: "/rflpprojects/[id]/rflpphysicsports/[rflpphysicsportsId]/owner",
    model: "LogicalPart",
    type: "dag-sub",
    sourceModel: "PhysicsPort",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "owner",
  },
  "project-full_reachable_physicsport_id_bound_to": {
    path: "/rflpprojects/[id]/rflpphysicsports/[rflpphysicsportsId]/bound-to",
    model: "LogicalPart",
    type: "dag-sub",
    sourceModel: "PhysicsPort",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "bound_to",
  },
  "project-full_reachable_requirement_id": {
    path: "/rflpprojects/[id]/rflprequirements/[rflprequirementsId]",
    model: "Requirement",
    type: "dag-sub-detail",
    sourceModel: "Project",
    publicRoute: false,
    parentDag: "project-full",
  },
  "project-full_reachable_requirement_id_attribute_values": {
    path: "/rflpprojects/[id]/rflprequirements/[rflprequirementsId]/attribute-values",
    model: "AttributeValue",
    type: "dag-sub",
    sourceModel: "Requirement",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "attribute_values",
  },
  "project-full_reachable_requirement_id_derived_values": {
    path: "/rflpprojects/[id]/rflprequirements/[rflprequirementsId]/derived-values",
    model: "DerivedValue",
    type: "dag-sub",
    sourceModel: "Requirement",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "derived_values",
  },
  "project-full_reachable_requirement_id_mentioned_in_expressions": {
    path: "/rflpprojects/[id]/rflprequirements/[rflprequirementsId]/mentioned-in-expressions",
    model: "Expression",
    type: "dag-sub",
    sourceModel: "Requirement",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "mentioned_in_expressions",
  },
  "project-full_reachable_requirement_id_satisfied_by": {
    path: "/rflpprojects/[id]/rflprequirements/[rflprequirementsId]/satisfied-by",
    model: "Action",
    type: "dag-sub",
    sourceModel: "Requirement",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "satisfied_by",
  },
  "project-full_reachable_requirement_id_verified_by_actions": {
    path: "/rflpprojects/[id]/rflprequirements/[rflprequirementsId]/verified-by-actions",
    model: "Action",
    type: "dag-sub",
    sourceModel: "Requirement",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "verified_by_actions",
  },
  "project-full_reachable_requirement_id_container": {
    path: "/rflpprojects/[id]/rflprequirements/[rflprequirementsId]/container",
    model: "LogicalPart",
    type: "dag-sub",
    sourceModel: "Requirement",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "container",
  },
  "project-full_reachable_requirement_id_sub_requirements": {
    path: "/rflpprojects/[id]/rflprequirements/[rflprequirementsId]/sub-requirements",
    model: "Requirement",
    type: "dag-sub",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "sub_requirements",
  },
  "project-full_reachable_requirement_id_refines": {
    path: "/rflpprojects/[id]/rflprequirements/[rflprequirementsId]/refines",
    model: "Requirement",
    type: "dag-sub",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "refines",
  },
  "project-full_reachable_requirement_id_refined_by": {
    path: "/rflpprojects/[id]/rflprequirements/[rflprequirementsId]/refined-by",
    model: "Requirement",
    type: "dag-sub",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "refined_by",
  },
  "project-full_reachable_requirement_id_derives_to": {
    path: "/rflpprojects/[id]/rflprequirements/[rflprequirementsId]/derives-to",
    model: "Requirement",
    type: "dag-sub",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "derives_to",
  },
  "project-full_reachable_requirement_id_derives_from": {
    path: "/rflpprojects/[id]/rflprequirements/[rflprequirementsId]/derives-from",
    model: "Requirement",
    type: "dag-sub",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "derives_from",
  },
  "project-full_reachable_requirement_id_conflicts_with": {
    path: "/rflpprojects/[id]/rflprequirements/[rflprequirementsId]/conflicts-with",
    model: "Requirement",
    type: "dag-sub",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "conflicts_with",
  },
  "project-full_reachable_requirement_id_conflicts_with_in": {
    path: "/rflpprojects/[id]/rflprequirements/[rflprequirementsId]/conflicts-with-in",
    model: "Requirement",
    type: "dag-sub",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "conflicts_with_in",
  },
  "project-full_reachable_requirement_id_constrained_by": {
    path: "/rflpprojects/[id]/rflprequirements/[rflprequirementsId]/constrained-by",
    model: "Constraint",
    type: "dag-sub",
    sourceModel: "Requirement",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "constrained_by",
  },
  "project-full_reachable_requirement_id_sources": {
    path: "/rflpprojects/[id]/rflprequirements/[rflprequirementsId]/sources",
    model: "SourceDocument",
    type: "dag-sub",
    sourceModel: "Requirement",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "sources",
  },
  "project-full_reachable_requirement_id_transformed_from": {
    path: "/rflpprojects/[id]/rflprequirements/[rflprequirementsId]/transformed-from",
    model: "StakeholderNeed",
    type: "dag-sub",
    sourceModel: "Requirement",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "transformed_from",
  },
  "project-full_reachable_requirement_id_frames_concerns": {
    path: "/rflpprojects/[id]/rflprequirements/[rflprequirementsId]/frames-concerns",
    model: "Concern",
    type: "dag-sub",
    sourceModel: "Requirement",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "frames_concerns",
  },
  "project-full_reachable_requirement_id_owning_part": {
    path: "/rflpprojects/[id]/rflprequirements/[rflprequirementsId]/owning-part",
    model: "RFLPElement",
    type: "dag-sub",
    sourceModel: "Requirement",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "owning_part",
  },
  "project-full_reachable_stakeholderneed_id": {
    path: "/rflpprojects/[id]/rflpstakeholderneeds/[rflpstakeholderneedsId]",
    model: "StakeholderNeed",
    type: "dag-sub-detail",
    sourceModel: "Project",
    publicRoute: false,
    parentDag: "project-full",
  },
  "project-full_reachable_stakeholderneed_id_attribute_values": {
    path: "/rflpprojects/[id]/rflpstakeholderneeds/[rflpstakeholderneedsId]/attribute-values",
    model: "AttributeValue",
    type: "dag-sub",
    sourceModel: "StakeholderNeed",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "attribute_values",
  },
  "project-full_reachable_stakeholderneed_id_derived_values": {
    path: "/rflpprojects/[id]/rflpstakeholderneeds/[rflpstakeholderneedsId]/derived-values",
    model: "DerivedValue",
    type: "dag-sub",
    sourceModel: "StakeholderNeed",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "derived_values",
  },
  "project-full_reachable_stakeholderneed_id_mentioned_in_expressions": {
    path: "/rflpprojects/[id]/rflpstakeholderneeds/[rflpstakeholderneedsId]/mentioned-in-expressions",
    model: "Expression",
    type: "dag-sub",
    sourceModel: "StakeholderNeed",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "mentioned_in_expressions",
  },
  "project-full_reachable_stakeholderneed_id_container": {
    path: "/rflpprojects/[id]/rflpstakeholderneeds/[rflpstakeholderneedsId]/container",
    model: "LogicalPart",
    type: "dag-sub",
    sourceModel: "StakeholderNeed",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "container",
  },
  "project-full_reachable_stakeholderneed_id_transformed_to": {
    path: "/rflpprojects/[id]/rflpstakeholderneeds/[rflpstakeholderneedsId]/transformed-to",
    model: "Requirement",
    type: "dag-sub",
    sourceModel: "StakeholderNeed",
    publicRoute: false,
    parentDag: "project-full",
    relationship: "transformed_to",
  },
  "rflp-project-by-id": {
    path: "/rflpprojects/[id]",
    linkPath: "/projects/[id]",
    model: "Project",
    type: "detail",
    query: "rflp-project-by-id",
    publicRoute: false,
    dagRoot: true,
  },
  "rflp-project-change-impacts": {
    path: "/rflpprojects/[id]/change-impacts",
    model: "ChangeImpact",
    type: "sub",
    query: "rflp-project-change-impacts",
    sourceModel: "Project",
    publicRoute: false,
    relationship: "change_impacts",
  },
  "rflp-proposal-batch-by-id": {
    path: "/rflpproposalbatchs/[id]",
    model: "ProposalBatch",
    type: "detail",
    query: "rflp-proposal-batch-by-id",
    publicRoute: false,
  },
  "rflp_tasks-search-rflp-context-items-workspace": {
    path: "/rflp-elements",
    model: "RFLPElement",
    type: "list",
    query: "rflp_tasks-search-rflp-context-items-workspace",
    publicRoute: false,
  },
  "rflp-requirement-by-id": {
    path: "/rflprequirements/[id]",
    linkPath: "/projects/[projectId]/requirement/[requirementId]",
    model: "Requirement",
    type: "detail",
    query: "rflp-requirement-by-id",
    publicRoute: false,
  },
  "base-effective-roster": {
    path: "/security-scopes/parent-scope/groups",
    model: "Group",
    type: "sub",
    query: "base-effective-roster",
    sourceModel: "SecurityScope",
    publicRoute: false,
    relationship: "groups",
  },
  "rflp-software-part-by-id": {
    path: "/rflpsoftwareparts/[id]",
    model: "SoftwarePart",
    type: "detail",
    query: "rflp-software-part-by-id",
    publicRoute: false,
  },
  "rflp-standard-by-id": {
    path: "/rflpstandards/[id]",
    model: "Standard",
    type: "detail",
    query: "rflp-standard-by-id",
    publicRoute: false,
  },
  "chat-step-by-id": {
    path: "/steps/[id]",
    model: "Step",
    type: "detail",
    query: "chat-step-by-id",
    publicRoute: false,
  },
  "chat-step-with-requests": {
    path: "/steps/[id]/model-requests",
    model: "ModelRequest",
    type: "sub",
    query: "chat-step-with-requests",
    sourceModel: "Step",
    publicRoute: false,
    relationship: "model_requests",
  },
  "rflp-succession-by-id": {
    path: "/rflpsuccessions/[id]",
    model: "Succession",
    type: "detail",
    query: "rflp-succession-by-id",
    publicRoute: false,
  },
  "pdm-search-context-items": {
    path: "/sysml-elements",
    model: "SysMLElement",
    type: "list",
    query: "pdm-search-context-items",
    publicRoute: false,
  },
  "task-full_thread": {
    path: "/tasks/[id]/threads",
    model: "Thread",
    type: "dag-sub",
    sourceModel: "Task",
    publicRoute: false,
    parentDag: "task-full",
    relationship: "thread",
  },
  "task-full_thread_id": {
    path: "/tasks/[id]/threads/[threadId]",
    model: "Thread",
    type: "dag-sub-detail",
    sourceModel: "Task",
    publicRoute: false,
    parentDag: "task-full",
    relationship: "thread",
  },
  "task-full_reachable_modelrequest_id": {
    path: "/tasks/[id]/model-requests/[model-requestsId]",
    model: "ModelRequest",
    type: "dag-sub-detail",
    sourceModel: "Task",
    publicRoute: false,
    parentDag: "task-full",
  },
  "task-full_reachable_modelrequest_id_system_prompt": {
    path: "/tasks/[id]/model-requests/[model-requestsId]/system-prompt",
    model: "SystemPrompt",
    type: "dag-sub",
    sourceModel: "ModelRequest",
    publicRoute: false,
    parentDag: "task-full",
    relationship: "system_prompt",
  },
  "task-full_reachable_modelrequest_id_model_response": {
    path: "/tasks/[id]/model-requests/[model-requestsId]/model-response",
    model: "ModelResponse",
    type: "dag-sub",
    sourceModel: "ModelRequest",
    publicRoute: false,
    parentDag: "task-full",
    relationship: "model_response",
  },
  "task-full_reachable_modelrequest_id_step": {
    path: "/tasks/[id]/model-requests/[model-requestsId]/step",
    model: "Step",
    type: "dag-sub",
    sourceModel: "ModelRequest",
    publicRoute: false,
    parentDag: "task-full",
    relationship: "step",
  },
  "task-full_reachable_modelresponse_id": {
    path: "/tasks/[id]/model-responses/[model-responsesId]",
    model: "ModelResponse",
    type: "dag-sub-detail",
    sourceModel: "Task",
    publicRoute: false,
    parentDag: "task-full",
  },
  "task-full_reachable_modelresponse_id_parts": {
    path: "/tasks/[id]/model-responses/[model-responsesId]/parts",
    model: "ResponsePart",
    type: "dag-sub",
    sourceModel: "ModelResponse",
    publicRoute: false,
    parentDag: "task-full",
    relationship: "parts",
  },
  "task-full_reachable_modelresponse_id_model_request": {
    path: "/tasks/[id]/model-responses/[model-responsesId]/model-request",
    model: "ModelRequest",
    type: "dag-sub",
    sourceModel: "ModelResponse",
    publicRoute: false,
    parentDag: "task-full",
    relationship: "model_request",
  },
  "task-full_reachable_questionnaire_id": {
    path: "/tasks/[id]/questionnaires/[questionnairesId]",
    model: "Questionnaire",
    type: "dag-sub-detail",
    sourceModel: "Task",
    publicRoute: false,
    parentDag: "task-full",
  },
  "task-full_reachable_questionnaire_id_tool_call_part": {
    path: "/tasks/[id]/questionnaires/[questionnairesId]/tool-call-part",
    model: "ToolCallPart",
    type: "dag-sub",
    sourceModel: "Questionnaire",
    publicRoute: false,
    parentDag: "task-full",
    relationship: "tool_call_part",
  },
  "task-full_reachable_questionnaire_id_questions": {
    path: "/tasks/[id]/questionnaires/[questionnairesId]/questions",
    model: "Question",
    type: "dag-sub",
    sourceModel: "Questionnaire",
    publicRoute: false,
    parentDag: "task-full",
    relationship: "questions",
  },
  "task-full_reachable_step_id": {
    path: "/tasks/[id]/steps/[stepsId]",
    model: "Step",
    type: "dag-sub-detail",
    sourceModel: "Task",
    publicRoute: false,
    parentDag: "task-full",
  },
  "task-full_reachable_step_id_thread": {
    path: "/tasks/[id]/steps/[stepsId]/thread",
    model: "Thread",
    type: "dag-sub",
    sourceModel: "Step",
    publicRoute: false,
    parentDag: "task-full",
    relationship: "thread",
  },
  "task-full_reachable_step_id_context_items": {
    path: "/tasks/[id]/steps/[stepsId]/context-items",
    model: "ScopedNode",
    type: "dag-sub",
    sourceModel: "Step",
    publicRoute: false,
    parentDag: "task-full",
    relationship: "context_items",
  },
  "task-full_reachable_step_id_model_requests": {
    path: "/tasks/[id]/steps/[stepsId]/model-requests",
    model: "ModelRequest",
    type: "dag-sub",
    sourceModel: "Step",
    publicRoute: false,
    parentDag: "task-full",
    relationship: "model_requests",
  },
  "chat-thread-by-id": {
    path: "/threads/[id]",
    model: "Thread",
    type: "detail",
    query: "chat-thread-by-id",
    publicRoute: false,
  },
  "chat-thread-with-steps": {
    path: "/threads/[id]/steps",
    model: "Step",
    type: "sub",
    query: "chat-thread-with-steps",
    sourceModel: "Thread",
    publicRoute: false,
    relationship: "steps",
  },
  "chat-thread-steps-requests": {
    path: "/threads/[id]/steps/model-requests",
    model: "ModelRequest",
    type: "sub",
    query: "chat-thread-steps-requests",
    sourceModel: "Thread",
    publicRoute: false,
    relationship: "model_requests",
  },
  "rflp-unit-by-id": {
    path: "/rflpunits/[id]",
    model: "Unit",
    type: "detail",
    query: "rflp-unit-by-id",
    publicRoute: false,
  },
  "base-all-users": {
    path: "/users",
    model: "User",
    type: "list",
    query: "base-all-users",
    publicRoute: false,
  },
  "base-user-by-id": {
    path: "/users/[id]",
    model: "User",
    type: "detail",
    query: "base-user-by-id",
    publicRoute: false,
  },
  "versioning-proposals": {
    path: "/versioning-overlays",
    model: "VersioningOverlay",
    type: "list",
    query: "versioning-proposals",
    publicRoute: false,
  },
  "base-all-workspaces": {
    path: "/workspaces",
    model: "Workspace",
    type: "list",
    query: "base-all-workspaces",
    publicRoute: false,
  },
  "tasks-workspace-tasks": {
    path: "/workspaces/tasks",
    model: "Task",
    type: "sub",
    query: "tasks-workspace-tasks",
    sourceModel: "Workspace",
    publicRoute: false,
    relationship: "tasks",
  },
  "chatskillstask-create": {
    path: "/chat-skills-tasks/[id]",
    linkPath: "/chat/[chatName]",
    model: "ChatSkillsTask",
    type: "detail",
    publicRoute: false,
  },
  "chattask-create": {
    path: "/chat-tasks/[id]",
    linkPath: "/chat/[chatName]",
    model: "ChatTask",
    type: "detail",
    publicRoute: false,
  },
  "concern-create": {
    path: "/rflpconcerns/[id]",
    model: "Concern",
    type: "detail",
    publicRoute: false,
  },
  "glossaryterm-create": {
    path: "/rflpglossaryterms/[id]",
    model: "GlossaryTerm",
    type: "detail",
    publicRoute: false,
  },
  "pdmpart-create": {
    path: "/parts/[id]",
    linkPath: "/part/[partId]",
    model: "PDMPart",
    type: "detail",
    publicRoute: false,
  },
  "pdmrequirement-create": {
    path: "/requirements/[id]",
    model: "PDMRequirement",
    type: "detail",
    publicRoute: false,
  },
  "pdmsupplychaincriteria-create": {
    path: "/supply-chain-criteria/[id]",
    model: "PDMSupplyChainCriteria",
    type: "detail",
    publicRoute: false,
  },
  "rflptask-create": {
    path: "/rflp-tasks/[id]",
    model: "RFLPTask",
    type: "detail",
    publicRoute: false,
  },
  "sourcedocument-create": {
    path: "/rflpsourcedocuments/[id]",
    model: "SourceDocument",
    type: "detail",
    publicRoute: false,
  },
} as const);

export type RouteKey = keyof typeof routeMap;

export const agents = [
  { name: "general-chat", taskClassName: "ChatTask", description: "General purpose chat agent", label: "General Chat", icon: "message-square" },
  { name: "skills-chat", taskClassName: "ChatSkillsTask", description: "Dynamic skills-based chat agent that discovers capabilities on demand", label: "Skills Chat", icon: "sparkles" },
  { name: "rflp", taskClassName: "RFLPTask", description: "Systems-engineering assistant: requirements → functional → logical → physical. Gemini-backed, skills-driven.", label: "RFLP", icon: "network" },
] as const;

export const modules = {
  base: { label: "BASE", models: ["Group", "Invite", "Organisation", "SecurityScope", "User", "Workspace"] },
  chat: { label: "CHAT", models: ["ModelRequest", "ModelResponse", "Step", "Thread"] },
  pdm: { label: "PDM", models: ["PDMAction", "PDMPart", "PDMProduct", "SysMLElement"] },
  pdm_tasks: { label: "PDM_TASKS", models: ["ChatSkillsTask", "ChatTask"] },
  rflp: { label: "RFLP", models: ["Action", "ActionInputParameter", "ActionOutputParameter", "AnalysisRecord", "AttributeValue", "ChangeImpact", "ChangeProposal", "Concern", "Connection", "Constraint", "ControlPort", "DerivedExpression", "DerivedValue", "DiscreteAttribute", "GitHubRepo", "GlossaryTerm", "InterfacePort", "Item", "ItemFlow", "LogicalPart", "NumericAttribute", "PhysicalPart", "PhysicsPort", "Project", "ProposalBatch", "Requirement", "SoftwarePart", "SourceDocument", "StakeholderNeed", "Standard", "Succession", "Unit"] },
  rflp_tasks: { label: "RFLP_TASKS", models: ["RFLPElement", "RFLPTask"] },
  tasks: { label: "TASKS", models: ["Questionnaire", "Task"] },
  versioning: { label: "VERSIONING", models: ["VersioningBranch", "VersioningCommit", "VersioningOp", "VersioningOverlay", "VersioningRelease"] },
} as const;
